import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import { loadTariffs } from './actions';
import { setSection } from '../Dictionaries/actions';
import { getCianRedirectUrl } from '../Home/actions';
import connectDataFetchers from '../../lib/connectDataFetchers';

import { ScrollToTopOnMount } from '../../ui/Common';
import { ScrollUp } from '../../ui/Controls';

import { capitalizeFirstLetter, percentage, truncText } from '../../utils/formater';

class Tariffs extends Component {
  constructor (props) {
    super(props);
    this.regionName = props.domain.get('domain', '') || '';

    this.renderTariffTablesGroup = this.renderTariffTablesGroup.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.renderTableRow = this.renderTableRow.bind(this);
    this.renderTableColumn = this.renderTableColumn.bind(this);
    this.renderSubHeader = this.renderSubHeader.bind(this);
    this.renderHint = this.renderHint.bind(this);
    this.getMaxIndexOfPricing = this.getMaxIndexOfPricing.bind(this);
  }

  componentDidUpdate (prevProps, prevState, prevContext) {
    ReactTooltip.rebuild();
  }

  componentDidMount () {
    this.props.loadTariffs();
  }

  getMaxIndexOfPricing (rubrics) {
    let max = -Infinity;
    let index = -1;
    rubrics.forEach((a, i) => {
      if (a.pricing.length > max) {
        max = a.pricing.length;
        index = i;
      }
    });
    return { index, pricingLength: max };
  };

  renderUserHeader (headerName, classModificator, description) {
    return (
      <div className='page-tariffs__header_details'>
        <div className={'page-tariffs__header_details-' + classModificator}>
          {`${headerName}`}
        </div>
        <div className='page-tariffs__header_details-description'>
          {description}
        </div>
      </div>
    );
  }

  renderTariffTablesGroup () {
    const { tariffs } = this.props;
    const tariffsAgency = tariffs.filter(i => i.userTypeId === 0);
    const tariffsUser = tariffs.filter(i => i.userTypeId === 3);

    return (
      <Fragment>
        {!!tariffs.length && !!tariffsUser.length &&
          <Fragment>
            {this.renderUserHeader('Для собственников:', 'for_owners', tariffsUser[0] && tariffsUser[0].description)}
            <div className='page-tariffs__table-container'>
              {this.renderTable(tariffsUser, 'sale', 'Продажа')}
              {this.renderTable(tariffsUser, 'rent', 'Аренда')}
              {this.renderTable(tariffsUser, 'commercials', 'Коммерческая недвижимость')}
            </div>
          </Fragment>
        }

        {!!tariffs.length && !!tariffsAgency.length &&
          <Fragment>
            {this.renderUserHeader('Для специалистов:', 'for_specialists', tariffsAgency[0] && tariffsAgency[0].description)}
            <div className='page-tariffs__table-container'>
              {this.renderTable(tariffsAgency, 'sale', 'Продажа')}
              {this.renderTable(tariffsAgency, 'rent', 'Аренда')}
              {this.renderTable(tariffsAgency, 'commercials', 'Коммерческая недвижимость')}
            </div>
          </Fragment>
        }
      </Fragment>
    );
  }

  renderSubHeader (column) {
    if (column.type !== 'single' && column.pricing.length > 2) {
      return (
        <tr>
          <td className='page-tariffs__table-sub-header'>цена</td>
          <td className='page-tariffs__table-sub-header'>скидка</td>
        </tr>
      );
    }
    if (column.pricing.length > 2) {
      return (
        <tr>
          <td className='page-tariffs__table-sub-header'>кол-во</td>
        </tr>
      );
    }
    return null;
  }

  renderHint (maxCount, minCount, price, firstPrice) {
    let limitations = [];
    if (firstPrice === 0 && price !== firstPrice) {
      limitations.push(`бесплатно ${minCount - 1}`);
    }
    if (maxCount !== null) {
      limitations.push(`не более ${maxCount}`);
    }
    return (!!limitations.length &&
      <span className='page-tariffs__counter'>
        {`(${limitations.join(', ')})`}
      </span>
    );
  }

  renderTableColumn (column, index, table, objectOfMax) {
    const columnLength = column.pricing.length;
    let columnName = column.name.split(' ');
    if (columnName.length !== 1) {
      columnName = columnName.splice(1);
    }
    columnName = columnName.join(' ');
    if (column.slug.includes('commercials') && column.name !== 'Объявлений') {
      columnName = column.slug.includes('sale') ? 'Продажа' : 'Аренда';
    }
    const firstPrice = column.pricing[0].costPerAdWithoutDiscount;
    if (column.pricing.length !== objectOfMax.pricingLength && columnLength > 2) {
      const diffPricing = objectOfMax.pricingLength - columnLength;
      const lastPricingItem = column.pricing[columnLength - 1];
      for (let i = 0; i < diffPricing; i += 1) {
        column.pricing.push(lastPricingItem);
      }
    }
    return (
      <table
        className={'page-tariffs__sub-table' + (index === 0 ? ' first' : '') + (index === table.length - 1 ? ' last' : '')}
        style={{width: `${1 / table.length * 100}%`}}
        key={column.name}
      >
        <tbody>
          <tr>
            <th>{capitalizeFirstLetter(truncText(columnName, 20, ''))}</th>
          </tr>
          <tr>
            <tbody>
              {this.renderSubHeader(column)}
              {
                column.pricing.map((row, index) => {
                  return this.renderTableRow(row, column, index, columnLength, firstPrice);
                })
              }
            </tbody>
          </tr>
        </tbody>
      </table>
    );
  }

  renderTableRow (row, column, index, columnLength, firstPrice) {
    if (row.costPerAdWithoutDiscount === 0 && columnLength === 2) {
      return null;
    }
    if (row.minCount && row.maxCount && columnLength > 2 && column.type === 'single') {
      return (
        <tr key={index}>
          <td>{`${row.minCount} — ${row.maxCount}`}</td>
        </tr>
      );
    }
    if (row.minCount && (row.maxCount === null) && columnLength > 2 && column.type === 'single') {
      return (
        <tr key={index}>
          <td>{`от ${row.minCount}`}</td>
        </tr>
      );
    }
    if (columnLength === 1 || columnLength === 2) {
      return (
        <tr key={index}>
          <td>
            {`${(row.costPerAdWithoutDiscount / 100).toFixed(2)} ₽`} {this.renderHint(row.maxCount, row.minCount, row.costPerAdWithoutDiscount, firstPrice)}
          </td>
        </tr>
      );
    }
    if (columnLength > 2) {
      return (
        <tr key={index}>
          <td>{`${(row.costPerAdWithoutDiscount / 100).toFixed(2)} ₽`}</td>
          {row.costPerAdWithoutDiscount !== firstPrice ? <td>{`${(Math.round(percentage(row.costPerAdWithoutDiscount, firstPrice) - 100))}%`}</td> : <td></td>}
        </tr>
      );
    }
  }

  renderTable (tariffTable, typeRubrics, label) {
    let rubrics = [];
    let otherRubrics = [];
    if (typeRubrics !== 'commercials') {
      rubrics = tariffTable[0] && tariffTable[0].rubrics && tariffTable[0].rubrics.filter(i => i.slug.includes(typeRubrics) && !i.slug.includes('commercials'));
      otherRubrics = tariffTable[0] && tariffTable[0].rubrics && tariffTable[0].rubrics.filter(i => !i.slug.includes(typeRubrics) && !i.slug.includes('commercials'));
    }
    if (typeRubrics === 'commercials') {
      rubrics = tariffTable[0] && tariffTable[0].rubrics && tariffTable[0].rubrics.filter(i => i.slug.includes('commercials'));
      otherRubrics = tariffTable[0] && tariffTable[0].rubrics && tariffTable[0].rubrics.filter(i => i.slug.includes('commercials'));
    }

    const objectOfMax = this.getMaxIndexOfPricing(rubrics);
    if (objectOfMax.pricingLength > 2) {
      const countersColumn = { type: 'single', ...rubrics[objectOfMax.index], name: 'Объявлений' };
      rubrics.unshift(countersColumn);
    }
    return (!!rubrics.length &&
      <div className={`page-tariffs__tariffTable${!!otherRubrics.length ? '' : ' first'}`}>
        <table>
          <tbody>
            <tr><th className='page-tariffs__table-header' colSpan={!!rubrics && rubrics.length || 1}>{label}</th></tr>
            <tr>
              { rubrics.map((column, index) => {
                return this.renderTableColumn(column, index, rubrics, objectOfMax);
              }) }
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render () {
    return (
      <div className='page-top-separator page-tariffs'>
        <div className='page-tariffs__wrapper'>
          <ScrollToTopOnMount />
          <div className='page-tariffs__header'>
            Методика расчета лицензионного вознаграждения
          </div>
          {this.renderTariffTablesGroup()}
          <ScrollUp showUnder={500} />
        </div>
      </div>
    );
  };
}

Tariffs.propTypes = {
  domain: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  loadTariffs: PropTypes.func.isRequired,
  tariffs: PropTypes.array.isRequired
};

Tariffs.defaultProps = {};

function mapStateToProps (state) {
  return {
    domain: state.get('domain'),
    tariffs: state.getIn(['tariffs', 'tariffs']).toJS()
  };
}

function mapDispatchToProps (dispatch) {
  const actions = bindActionCreators({
    loadTariffs,
    setSection
  }, dispatch);

  actions.dispatch = dispatch;
  return actions;
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  connectDataFetchers(Tariffs, [loadTariffs, getCianRedirectUrl])
));



// WEBPACK FOOTER //
// ./src/app/Tariffs/Tariffs.jsx